// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-takeaways__list--list {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}
.block-takeaways__card {
  overflow: hidden;
  box-shadow: none;
}
.block-takeaways__card--content--text {
  margin-bottom: 2rem;
}
.block-takeaways__card--content--cta {
  margin-bottom: 0;
}
.block-takeaways__card .ant-card-meta-title {
  font-size: var(--takeaways-title-font-size-desktop);
}
.block-takeaways__card .ant-card-meta-description {
  font-size: var(--takeaways-description-font-size-desktop);
}
@media (max-width: 768px) {
  .block-takeaways__card .ant-card-body {
    padding-left: 0;
    padding-right: 0;
  }
  .block-takeaways__card .ant-card-meta-title {
    font-size: var(--takeaways-title-font-size-mobile);
  }
  .block-takeaways__card .ant-card-meta-description {
    font-size: var(--takeaways-description-font-size-mobile);
  }
}
@media (min-width: 768px) {
  .block-takeaways__list--list .block-takeaways__card {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }
  .block-takeaways__list--list .block-takeaways__card .ant-card-cover,
  .block-takeaways__list--list .block-takeaways__card .ant-card-body {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .block-takeaways__list--list .block-takeaways__card .ant-card-body {
    display: flex;
    align-items: center;
  }
  .block-takeaways__list--list .block-takeaways__card.block-takeaways__card--reverse {
    flex-direction: row-reverse;
  }
}
.block-takeaways__cover {
  height: 100%;
}
.block-takeaways__cover img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Takeaways/Takeaways.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAFR;AAKI;EACI,gBAAA;EACA,gBAAA;AAHR;AAMY;EACI,mBAAA;AAJhB;AAMY;EACI,gBAAA;AAJhB;AAQQ;EACI,mDAAA;AANZ;AASQ;EACI,yDAAA;AAPZ;AAUQ;EACI;IACI,eAAA;IACA,gBAAA;EARd;EAWU;IACI,kDAAA;EATd;EAYU;IACI,wDAAA;EAVd;AACF;AAaQ;EACI;IACI,aAAA;IACA,mBAAA;IACA,oBAAA;EAXd;EAac;;IAEI,aAAA;IACA,cAAA;EAXlB;EAcc;IACI,aAAA;IACA,mBAAA;EAZlB;EAec;IACI,2BAAA;EAblB;AACF;AAkBI;EACI,YAAA;AAhBR;AAkBQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAhBZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
